/*
  Action Types
 */

export const GET_LOCALITIES_SUCCESS = "GET_LOCALITIES_SUCCESS";
export const CLEAR_LOCALITIES = "CLEAR_LOCALITIES";

export const ADDRESS_CHANGE_STATUSES = {
    PENDING_APPROVAL: 1,
    PENDING_FURTHER_INFO: 3
};

export const GET_JOB_ADDRESS_DETAILS_SUCCCESS = "GET_JOB_ADDRESS_DETAILS_SUCCCESS";
export const GET_JOB_ADDRESS_DETAILS_BEGIN = "GET_JOB_ADDRESS_DETAILS_BEGIN";

export const UPDATE_JOB_ADDRESS_DETAILS_SUCCCESS = "UPDATE_JOB_ADDRESS_DETAILS_SUCCCESS";
export const UPDATE_JOB_ADDRESS_DETAILS_BEGIN = "UPDATE_JOB_ADDRESS_DETAILS_BEGIN";


// WEBPACK FOOTER //
// ./app/address/constants/addressConstants.js